import { useEffect } from 'react';

interface HelmetProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  schema?: Record<string, unknown>;
}

export function Helmet({ title, description, keywords, canonicalUrl, schema }: HelmetProps) {
  useEffect(() => {
    const originalTitle = document.title;
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', canonicalUrl);

    let schemaEl: HTMLScriptElement | null = null;
    if (schema) {
      schemaEl = document.createElement('script');
      schemaEl.type = 'application/ld+json';
      schemaEl.textContent = JSON.stringify(schema);
      document.head.appendChild(schemaEl);
    }

    return () => {
      document.title = originalTitle;
      if (schemaEl) document.head.removeChild(schemaEl);
    };
  }, [title, description, keywords, canonicalUrl, schema]);

  return null;
}